export const automaticGenerated = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'barcode.utils.library-table-titles.name',
  },
  {
    id: 'label',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.label',
  },
  {
    id: 'digits',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.digits',
  },
  {
    id: 'lastGenerated',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.last-generated',
  },
  {id: 'groupAction', numeric: true, disablePadding: false, label: ''},
]

export const fieldValue = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'barcode.utils.library-table-titles.name',
  },
  {
    id: 'label',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.label',
  },
  {
    id: 'entityId',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.group',
  },
  {
    id: 'fieldId',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.field',
  },
  {id: 'groupAction', numeric: true, disablePadding: false, label: ''},
]

export const tableSheets = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'barcode.utils.library-table-titles.name',
  },
  {
    id: 'size',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.size',
  },
  {
    id: 'rows',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.rows',
  },
  {
    id: 'columns',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.columns',
  },
  {id: 'groupAction', numeric: true, disablePadding: false, label: ''},
]

export const tableLabels = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'barcode.utils.library-table-titles.name',
  },
  {
    id: 'width',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.width',
  },
  {
    id: 'height',
    numeric: true,
    disablePadding: false,
    label: 'barcode.utils.library-table-titles.height',
  },
  {id: 'groupAction', numeric: true, disablePadding: false, label: ''},
]
